export default class Validation {
  constructor() {
    console.log('Validation');
  }

  /**
   * @define showError
   * @description Show error message
   * @param  input
   * @param  message
   * @return void
   */
  showError(input: HTMLInputElement, message: string) {
    let formGroup: HTMLElement | null = input.parentElement;

    if (input?.parentElement?.classList.contains('iti')) {
      formGroup = input.parentElement.parentElement;
    }

    if (formGroup) {
      if (formGroup.classList.contains('o-validation--success')) {
        formGroup.classList.remove('o-validation', 'o-validation--success');
      }
      formGroup.classList.add('o-validation', 'o-validation--error');
      const errorMessage = formGroup.querySelector(
        '.o-validation__message-text'
      ) as HTMLElement;
      errorMessage.innerText = message;
    }
  }

  /**
   * @define showSuccess
   * @description Show success message
   * @param  input
   * @return void
   */
  showSuccess(input: HTMLInputElement) {
    let formGroup: HTMLElement | null = input.parentElement;

    if (input?.parentElement?.classList.contains('iti')) {
      formGroup = input.parentElement.parentElement;
    }

    if (formGroup) {
      if (formGroup.classList.contains('o-validation--error')) {
        formGroup.classList.remove('o-validation', 'o-validation--error');
      }
      formGroup.classList.add('o-validation', 'o-validation--success');
      const errorMessage = formGroup.querySelector(
        '.o-validation__message-text'
      ) as HTMLElement;
      errorMessage.innerText = '';
    }
  }

  /**
   * @define validatePassword
   * @description Validate password field
   * @param  formElementInfo
   * @return void
   */
  validatePassword(formElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;
    const formElementValue = formElement.value.trim();

    if (formElementValue === '') {
      self.showError(formElement, formElementInfo.errorMessage.empty);
      return false;
    } else if (formElementValue.length < formElementInfo.minChar) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else if (formElementValue.length > formElementInfo.maxChar) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else if (
      formElementInfo.regex !== '' &&
      !formElementValue.match(formElementInfo.regex)
    ) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else {
      self.showSuccess(formElement);
      return true;
    }
  }

  /**
   * @define validateConfirmPassword
   * @description Validate confirm password field
   * @param  formElementInfo - confirm form element info
   * @param  passwordElementInfo - main password element info
   * @return void
   */
  validateConfirmPassword(formElementInfo: any, passwordElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;
    const formElementValue = formElement.value.trim();

    // first password element
    const passwordElement = document.getElementById(
      passwordElementInfo.id
    ) as HTMLInputElement;
    const passwordElementValue = passwordElement.value.trim();

    if (formElementValue !== passwordElementValue) {
      self.showError(formElement, formElementInfo.errorMessage.mismatch);
      return false;
    } else {
      self.showSuccess(formElement);
      return true;
    }
  }

  /**
   * @define validateEmail
   * @description Validate email field
   * @param  formElementInfo
   * @return void
   */
  validateEmail(formElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;
    const formElementValue = formElement.value.trim();

    if (formElementValue === '') {
      self.showError(formElement, formElementInfo.errorMessage.empty);
      return false;
    } else if (formElementValue.length < formElementInfo.minChar) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else if (formElementValue.length > formElementInfo.maxChar) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else if (!formElementValue.match(formElementInfo.regex)) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else {
      self.showSuccess(formElement);
      return true;
    }
  }

  /**
   * @define validateCode
   * @description Validate code field
   * @param  formElementInfo
   * @return void
   */
  validateCode(formElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;
    const formElementValue = formElement.value.trim();

    if (formElementValue === '') {
      self.showError(formElement, formElementInfo.errorMessage.empty);
      return false;
    } else if (formElementValue.length < formElementInfo.minChar) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else if (formElementValue.length > formElementInfo.maxChar) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else if (!formElementValue.match(formElementInfo.regex)) {
      self.showError(formElement, formElementInfo.errorMessage.invalid);
      return false;
    } else {
      self.showSuccess(formElement);
      return true;
    }
  }

  /**
   * @define validateText
   * @description Validate text field
   * @param  formElementInfo
   * @return void
   */
  validateText(formElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;

    let formElementValue = formElement.value.trim();

    if (formElement?.parentElement?.classList.contains('iti')) {
      // get hidden input value sibling of form element
      formElementValue = (
        formElement?.parentElement?.querySelector(
          'input[type="hidden"]'
        ) as HTMLInputElement
      ).value.trim();
    }

    if (formElementInfo.required) {
      if (formElementValue === '') {
        self.showError(formElement, formElementInfo.errorMessage.empty);
        return false;
      } else if (
        formElementInfo.minChar &&
        formElementValue.length < formElementInfo.minChar
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else if (
        formElementInfo.maxChar &&
        formElementValue.length > formElementInfo.maxChar
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else if (
        formElementInfo.regex !== '' &&
        !formElementValue.match(formElementInfo.regex)
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else {
        self.showSuccess(formElement);
        return true;
      }
    } else {
      return true;
    }
  }

  /**
   * @define validateNumber
   * @description Validate number field
   * @param  formElementInfo
   * @return void
   */
  validateNumber(formElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;
    const formElementValue = formElement.value.trim();
    if (formElementInfo.required) {
      if (formElementValue === '') {
        self.showError(formElement, formElementInfo.errorMessage.empty);
        return false;
      } else if (
        formElementInfo.min &&
        parseInt(formElementValue, 10) < formElementInfo.min
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else if (
        formElementInfo.max &&
        parseInt(formElementValue, 10) > formElementInfo.max
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else if (
        formElementInfo.regex !== '' &&
        !formElementValue.match(formElementInfo.regex)
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else {
        self.showSuccess(formElement);
        return true;
      }
    } else {
      return true;
    }
  }

  /**
   * @define validateDate
   * @description Validate date field
   * @param  formElementInfo
   * @return void
   */
  validateDate(formElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;
    const formElementValue = formElement.value.trim();

    if (formElementInfo.required) {
      if (formElementValue === '') {
        self.showError(formElement, formElementInfo.errorMessage.empty);
        return false;
      } else if (
        formElementInfo.minChar &&
        formElementValue.length < formElementInfo.minChar
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else if (
        formElementInfo.maxChar &&
        formElementValue.length > formElementInfo.maxChar
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else if (
        formElementInfo.regex !== '' &&
        !formElementValue.match(formElementInfo.regex)
      ) {
        self.showError(formElement, formElementInfo.errorMessage.invalid);
        return false;
      } else {
        self.showSuccess(formElement);
        return true;
      }
    } else {
      return true;
    }
  }

  /**
   * @define validateSelect
   * @description Validate select field
   * @param  formElementInfo
   * @return void
   */
  validateSelect(formElementInfo: any) {
    const self = this;

    const formElement = document.getElementById(
      formElementInfo.id
    ) as HTMLInputElement;
    const formElementValue = formElement.value.trim();

    if (formElementInfo.required) {
      if (formElementValue === '' || formElementValue === '0') {
        self.showError(formElement, formElementInfo.errorMessage.empty);
        return false;
      } else {
        self.showSuccess(formElement);
        return true;
      }
    } else {
      self.showSuccess(formElement);
      return true;
    }
  }

  isEmpty(str: any) {
    return !str || str.length === 0;
  }
}
